import React from "react";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { UnifiedReturnsTable } from "./UnifiedReturnsTable";
import { DamagedItemsTable } from "./DamagedItemsTable";
import { InventoryStats } from "./InventoryStats";
import { FilterSection, Tabs } from "@/components/ui";
import DateFilter from "@/components/ui/DateFilter";
import { RotateCcw } from "lucide-react";
import { useDamagedItems } from "../hooks/useDamagedItems";

export const ReturnsView = ({
  returnsSubTab,
  setReturnsSubTab,
  search,
  setSearch,
  filters,
  setFilters,
  dynamicSettings,
  activeTab,
  activeReturnFilterOptions,
  consolidatedReturns,
  setSelReturn,
  setSelPR,
  setSelSR,
  setPurchaseReturnOpen,
  setSaleReturnOpen,
  handleConfirmReturn,
  setViewPaymentData,
  setSelectedPRForPayment,
  onExport,
  isExporting,
}) => {
  console;
  const masterReturnType = filters.returnType || "all";
  /* const masterReturns = consolidatedReturns.filter((r) => {
    const type = (r.rawType || r.returnType || "").toLowerCase();
    if (masterReturnType === "site") return type === "site" || type === "sale";
    if (masterReturnType === "purchase") return type === "purchase";
    return true;
  }); */

  const { damagedReturns } = useDamagedItems(consolidatedReturns);
  
  const siteReturns = consolidatedReturns.filter(
    (r) => r.rawType === "site" || r.rawType === "sale" || r.returnType === "Site" || r.returnType === "Sale",
  );

  const purchaseReturns = consolidatedReturns.filter(
    (r) => r.rawType === "purchase" || r.returnType === "Purchase",
  );

  const renderReturnsContent = () => {
    switch (returnsSubTab) {
      /* case "master":
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <FilterSection
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={(key, value) => setFilters((prev) => ({ ...prev, [key]: value }))}
              onExport={() => onExport(masterReturns)}
              isExporting={isExporting}
            >
              <div className="bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0 flex items-center gap-2">
                <select
                  className="text-[13px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-600 min-w-[170px]"
                  value={masterReturnType}
                  onChange={(e) => setFilters((prev) => ({ ...prev, returnType: e.target.value }))}
                >
                  <option value="all">All Return Types</option>
                  <option value="site">Sale Returns</option>
                  <option value="purchase">Purchase Returns</option>
                </select>
              </div>

              <button
                onClick={() => setFilters((prev) => ({ ...prev, returnType: "all", date: "all", fromDate: "", toDate: "" }))}
                className="p-1.5 h-8 w-8 flex items-center justify-center rounded-md border border-slate-200 text-slate-400 hover:bg-white hover:text-brand-blue hover:border-brand-blue/30 transition-all group"
                title="Reset Filters"
              >
                <RotateCcw size={14} className="group-hover:rotate-[-45deg] transition-transform" />
              </button>
            </FilterSection>
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-black uppercase tracking-widest text-slate-500">
                Master Returns
              </h2>
              <p className="text-xs text-brand-blue font-medium bg-blue-50 px-3 py-1 rounded-full border border-blue-100 shadow-sm">
                All Inward Flow (Site, Purchase, Sale)
              </p>
            </div>
            <UnifiedReturnsTable
              returns={masterReturns}
              subTab={returnsSubTab}
              onView={(r) => {
                const type = r.rawType || r.returnType?.toLowerCase();
                if (type === "site") setSelReturn(r.originalData || r);
                else if (type === "purchase") setSelPR(r.originalData || r);
                else if (type === "sale") setSelSR(r.originalData || r);
              }}
              onEdit={(r) => {
                const type = r.rawType || r.returnType?.toLowerCase();
                if (type === "purchase") {
                  setSelPR(r.originalData || r);
                  setPurchaseReturnOpen(true);
                } else if (type === "sale") {
                  setSelSR(r.originalData || r);
                  setSaleReturnOpen(true);
                }
              }}
              onConfirm={(item, action) => handleConfirmReturn(item, action)}
              onViewPayment={(r) =>
                setSelectedPRForPayment(r.originalData || r)
              }
              onGoToTab={setReturnsSubTab}
            />
          </div>
        ); */
      case "sale":
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              onView={(r) => {
                const type = r.rawType || r.returnType?.toLowerCase();
                if (type === "site") setSelReturn(r.originalData || r);
                else if (type === "purchase") setSelPR(r.originalData || r);
                else if (type === "sale") setSelSR(r.originalData || r);
              }}
              onEdit={(r) => {
                const type = r.rawType || r.returnType?.toLowerCase();
                if (type === "purchase") {
                  setSelPR(r.originalData || r);
                  setPurchaseReturnOpen(true);
                } else if (type === "sale") {
                  setSelSR(r.originalData || r);
                  setSaleReturnOpen(true);
                }
              }}
              onConfirm={(item, action) => handleConfirmReturn(item, action)}
              onViewPayment={(r) =>
                setSelectedPRForPayment(r.originalData || r)
              }
              onGoToTab={setReturnsSubTab}
            />
          </div>
        );
      case "site":
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={setFilters}
              dynamicSettings={dynamicSettings}
              categories={activeReturnFilterOptions?.categories}
              parties={activeReturnFilterOptions?.parties}
              partyLabel="Customers"
              showStatusFilter={false}
              showVendorFilter={false}
              showCustomerFilter={true}
              onExport={() => onExport(siteReturns)}
              isExporting={isExporting}
            />
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-medium text-slate-500">
                Sale Returns
              </h2>
              <p className="text-xs text-blue-500 font-medium bg-blue-50 px-3 py-1 rounded-full border border-blue-100 shadow-sm">
                Unused Material Returning to Store
              </p>
            </div>
            <UnifiedReturnsTable
              returns={siteReturns}
              subTab={returnsSubTab}
              onView={(r) => setSelReturn(r.originalData || r)}
              onConfirm={(item, action) => handleConfirmReturn(item, action)}
              onViewPayment={(r) =>
                setSelectedPRForPayment(r.originalData || r)
              }
              onGoToTab={setReturnsSubTab}
            />
          </div>
        );
      case "purchases":
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={setFilters}
              dynamicSettings={dynamicSettings}
              onAddItemClick={() => {
                setSelPR(null);
                setPurchaseReturnOpen(true);
              }}
              buttonLabel="Return"
              categories={activeReturnFilterOptions?.categories}
              parties={activeReturnFilterOptions?.parties}
              partyLabel="Parties"
              showStatusFilter={false}
              showVendorFilter={false}
              showCustomerFilter={false}
              onExport={() => onExport(purchaseReturns)}
              isExporting={isExporting}
            />
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-black uppercase tracking-widest text-slate-500">
                Purchase Returns
              </h2>
            </div>
            <UnifiedReturnsTable
              returns={purchaseReturns}
              subTab={returnsSubTab}
              onView={(r) => setSelPR(r.originalData || r)}
              onEdit={(r) => {
                setSelPR(r.originalData || r);
                setPurchaseReturnOpen(true);
              }}
              onConfirm={(item, action) => handleConfirmReturn(item, action)}
              onViewPayment={(r) =>
                setSelectedPRForPayment(r.originalData || r)
              }
              onGoToTab={setReturnsSubTab}
            />
          </div>
        );
      case "damaged":
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <InventoryControlPanel
              activeTab={activeTab}
              search={search}
              setSearch={setSearch}
              filters={filters}
              setFilters={setFilters}
              dynamicSettings={dynamicSettings}
              categories={activeReturnFilterOptions?.categories}
              parties={activeReturnFilterOptions?.parties}
              partyLabel="Parties"
              showStatusFilter={false}
              showVendorFilter={false}
              showCustomerFilter={true}
              onExport={() => onExport(damagedReturns)}
              isExporting={isExporting}
            />
            <div className="flex items-center justify-between mb-4 px-2">
              <h2 className="text-[11px] font-black uppercase tracking-widest text-red-500">
                Damaged Items
              </h2>
              <p className="text-xs text-red-500 font-medium bg-red-50 px-3 py-1 rounded-full border border-red-100 shadow-sm">
                Items with damage reports from returns
              </p>
            </div>
            <DamagedItemsTable
              returns={consolidatedReturns}
              onView={(r) => {
                const type = r.rawType || r.returnType?.toLowerCase();
                if (type === "site") setSelReturn(r.originalData || r);
                else if (type === "purchase") setSelPR(r.originalData || r);
                else if (type === "sale") setSelSR(r.originalData || r);
              }}
            />
          </div>
        );
    }
  };

  return (
    <div className="space-y-6">
      {/* <InventoryStats
        activeTab={activeTab}
        viewMode="returns"
        subTab={returnsSubTab}
        isExpanded={false}
        setIsExpanded={() => {}}
        inventory={[]}
        sales={[]}
        returns={consolidatedReturns}
        requests={[]}
        purchaseReturns={consolidatedReturns.filter(
          (r) => r.rawType === "purchase" || r.returnType === "Purchase",
        )}
      /> */}

      {/* <Tabs
        tabs={[
          { id: "master", label: "Returns Master" },
          { id: "purchases", label: "Purchase Returns" },
          { id: "site", label: "Sale Returns" },
          { id: "damaged", label: "Damaged Items" },
        ]}
        activeTab={returnsSubTab}
        onChange={(id) => {
          setReturnsSubTab(id);
          setSearch("");
        }}
        variant="sub"
        className="mb-2"
      /> */}
      {renderReturnsContent()}
    </div>
  );
};